import { Card, Carousel } from 'antd';
import { useTranslation } from 'react-i18next';
import { FaQuoteLeft } from 'react-icons/fa6';
import { createUseStyles } from 'react-jss';
import { colors } from 'design';

const useStyles = createUseStyles({
  carouselContainer: {
    width: '100%',
    padding: 32,
    marginTop: 8,
  },
  exampleMessageIcon: {
    marginRight: 10,
    color: colors.brand.accentStrong,
  },
  exampleMessage: {
    backgroundColor: 'white',
    marginBottom: 5,
    color: colors.text.tertiary,
    boxShadow: 'none',
    fontWeight: 'bold',
  },
});

export default function ExampleQuestions() {
  // Hooks
  const { t } = useTranslation();
  const styles = useStyles();

  return (
    <div className={styles.carouselContainer}>
      <Carousel autoplay>
        {t<string, { returnObjects: true }, string[]>('chats.new.exampleMessages', { returnObjects: true }).map(
          (message, index) => (
            <Card key={`card-${index}`} size="small" bordered={false} className={styles.exampleMessage}>
              <FaQuoteLeft className={styles.exampleMessageIcon} />
              {message}
            </Card>
          ),
        )}
      </Carousel>
    </div>
  );
}
